export default __webpack_public_path__ + "images/3d881961141e53a0ce8c48f58b321635-foot-right.svg";